import React, { useState } from "react";
import "./webview.css";
import Icon from "../../Icon/Icon";
import useMailMerge from "./useMailMerge/useMailMerge";
import CardSkeleton from "../../Skeleton/Card";

export default function WebView({ widgetInformation = {} }) {
  const { config = {}, identifier } = widgetInformation;
  const { url, loading, error, initialize } = useMailMerge(config);
  console.log(url);
  const [zoomScale, setZoomScale] = useState("1.0");
  const [zoomPercentage, setZoomPercentage] = useState("100%");
  const handleZoomIn = (e) => {
    e.stopPropagation();
    const newZoom = Math.min(Number(zoomScale) + 0.1, 1.5).toFixed(1);
    setZoomPercentage((100 / Number(newZoom)).toFixed(2) + "%");
    setZoomScale(newZoom);
  };

  const handleZoomOut = (e) => {
    e.stopPropagation();
    const newZoom = Math.max(Number(zoomScale) - 0.1, 0.5).toFixed(1);
    setZoomPercentage((100 / Number(newZoom)).toFixed(2) + "%");
    setZoomScale(newZoom);
  };
  const openInNewWindow = () => {
    window.open(url, "_blank", "noopener,noreferrer");
  };
  if (loading) {
    return <CardSkeleton size="large" />;
  }
  if (error) {
    return (
      <span
        className="webview-widget-retry-button"
        onClick={(e) => {
          e.stopPropagation();
          initialize();
        }}
      >
        retry
      </span>
    );
  }

  return (
    <div className={`webview-widget widget-container`}>
      <button
        onClick={openInNewWindow}
        className="navigate-button"
        aria-label="Open in new window"
      >
        <Icon
          src={`images/${"lsq_external_link_white"}.svg`}
          alt="icon"
          className="icon"
          isWidgetIcon={false}
          color="black"
        />
      </button>
      <div className="zoom-controls">
        <div onClick={handleZoomIn}>+</div>
        <div onClick={handleZoomOut}>-</div>
      </div>
      <div className="frame">
        <iframe
          target="_parent"
          src={url}
          role="web-view"
          title={identifier}
          style={{
            width: zoomPercentage,
            height: zoomPercentage,
            transform: `scale(${zoomScale})`,
            transformOrigin: "0% 0%",
          }}
        ></iframe>
      </div>
    </div>
  );
}
